
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remyndProduct/create",
      function () {
        return require("private-next-pages/remyndProduct/create.tsx");
      }
    ]);
  